import { IAppState } from 'src/interface/IAppState';
import { InotificationState } from 'src/interface/INotificationState';

export const notificatonSelector = (appState: IAppState): InotificationState =>
  appState.notificationState;
